module.exports = __webpack_public_path__ + "static/img/180153_7.19a7123.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/180153_7.jpg
// module id = rH8F
// module chunks = 1